import React from 'react';
import { useTranslation } from 'react-i18next';
import { PanelLeft } from 'lucide-react';
import { PaletteItem } from './WorkflowNodes';

interface NodePaletteProps {
    onMouseDown?: (event: React.MouseEvent, nodeType: string) => void;
    onDragStart?: (event: React.DragEvent, nodeType: string) => void;
    /** When set, a small PanelLeft button appears to the right of the
     *  "Workflow-Elemente" header; clicking calls this handler. The
     *  parent (BpmnWorkflowEditor) owns the collapsed state. */
    onCollapse?: () => void;
}

export default function NodePalette({ onMouseDown, onDragStart, onCollapse }: NodePaletteProps) {
    const { t } = useTranslation();

    const paletteItems = [
        { type: 'pool' as const, label: t('workflowEditor.nodePalette.pool') },
        { type: 'start' as const, label: 'Start' },
        { type: 'end' as const, label: 'End' },
        { type: 'mcp-tool' as const, label: 'MCP-Werkzeug' },
        { type: 'knowledge-base' as const, label: 'Wissensbasis' },
        { type: 'prompt-tool' as const, label: 'Prompt-Werkzeug' },
        { type: 'workflow-tool' as const, label: 'Workflow' },
        { type: 'xor' as const, label: 'XOR' },
        { type: 'and' as const, label: 'AND' },
        { type: 'manual' as const, label: 'Manuelle Aufgabe' }
    ];

    return (
        <div className="node-palette">
            <div className="palette-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="headerM marginBottomS">{t('workflowEditor.nodePalette.workflowElements')}</div>
                {onCollapse && (
                    <button
                        type="button"
                        onClick={onCollapse}
                        title={t('workflowEditor.collapsePalette', 'Hide element palette')}
                        aria-label={t('workflowEditor.collapsePalette', 'Hide element palette')}
                        className="bpmn-palette-toggle"
                    >
                        <PanelLeft size={16} />
                    </button>
                )}
            </div>
            <div className="palette-items palette-items-grid">
                {paletteItems.map((item) => (
                    <PaletteItem
                        key={item.type}
                        type={item.type}
                        label={item.label}
                        onMouseDown={onMouseDown}
                        onDragStart={onDragStart}
                    />
                ))}
            </div>
        </div>
    );
}
